import { Select, type SelectProps } from '@brokerbay/elements-web';
import React, { useRef } from 'react';

export type SelectAgentInputProps = Pick<
  SelectProps<string, { value: number; label: JSX.Element }>,
  | 'searchValue'
  | 'onKeyDown'
  | 'onChange'
  | 'onSearch'
  | 'id'
  | 'dataCy'
  | 'options'
>;

const SelectAgentInput: React.FC<SelectAgentInputProps> = props => {
  // Used to prevent antd auto clear on input blur
  const inputBlurred = useRef<boolean>(false);
  const { onSearch } = props;

  const handleSearch = async (value: string) => {
    // Check if this fn was called from a blur event and prevent antd from auto-clearing the search value
    if (!value) {
      // This fn gets triggered before onBlur so pause it until sync operations are done
      await new Promise(res => setTimeout(res, 0));
      if (inputBlurred.current) {
        inputBlurred.current = false;
        return;
      }
    }
    if (onSearch) {
      return onSearch(value);
    }
  };

  return (
    <Select<string, { value: number; label: JSX.Element }>
      size="small"
      autoFocus
      showSearch
      // Prevents trying to display the JSX element in search bar after selecting
      value=""
      {...props}
      onSearch={handleSearch}
      onBlur={() => {
        inputBlurred.current = true;
      }}
      filterOption={false}
    />
  );
};

export default SelectAgentInput;
